import  {useState, useEffect } from 'react'
import { Typography, Button, Paper, Box,Slider, Rating } from '@mui/material';
import { customSlider, colors } from "../../Theme"
import { ReactComponent as Logo } from "../../img/logo.svg"
import { ReactComponent as ColorRating } from "../../img/colorRating.svg"
import { ReactComponent as GreyRating } from "../../img/greyRating.svg"
import CryptoProfile from "../../img/VerifyEmail.png"
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../../API/AxiosInstance';
import UnsubscribeIcon from '../../img/unsubscribeIcon.png';
import { captureException } from '@sentry/react';
import { useAuth0 } from '@auth0/auth0-react';


export default function Questionaire() {
    const [questDatas, setQuestDatas] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0)
    const [answerValues, setAnswerValues] = useState([])
    const [isNextEnabled, setIsNextEnabled] = useState(false);
    const [isContinue, setIsContinue] = useState(false)
    const [complete, setIsComplete] = useState(false)
    const [error, setError] = useState(false)
    const { user } = useAuth0();

    const navigate = useNavigate()
    useEffect(() => {
        getQuestions()
    },[])

    const getQuestions = async() => {
        try {
            const response = await ApiService().get('questionnaire/questions')
            if(response?.data?.questions) {
                setQuestDatas(response?.data?.questions)
            }
        } catch(error) {
            captureException(error)
        }
        
    }

const CustomButton = ({ children, onClick, selected }) => {
  return (
    <Button
      onClick={onClick}
      disableRipple
      sx={{
        width: { xs: '100%', sm: '262.92px' },
        minHeight: '47.44px',
        borderRadius: '7.93px',
        padding: '13.72px 18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'left',
        textTransform: 'none',
        backgroundColor: selected ? colors.background.default : colors.background.paper,
        border: `1.5px solid ${selected ? colors.primary.main : colors.border.default}`,
        boxShadow: `0px 2px 6px ${colors.border.card}`,
        color: colors.text.primary,
        fontWeight: selected ? 600 : 550,
        '&:hover': {
          backgroundColor: selected ? colors.background.default : colors.background.paper,
          borderColor: colors.primary.main,
        },
      }}
    >
      <span>{children}</span>
      <Box
        component="span"
        sx={{
          width: 18,
          height: 18,
          borderRadius: '50%',
          border: `2px solid ${selected ? colors.primary.main : colors.border.light}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          ml: '12px',
        }}
      >
        {selected && (
          <Box
            component="span"
            sx={{
              width: 9,
              height: 9,
              borderRadius: '50%',
              backgroundColor: colors.primary.main,
            }}
          />
        )}
      </Box>
    </Button>
  );
};

      useEffect(() => {
        if (questDatas.length > 0) {
            const currentQuestion = questDatas[currentIndex];
            if (currentQuestion.questionType === 'SELECTION' && !answerValues[currentIndex]?.answerValue?.id) {
                setIsNextEnabled(false); 
            } else {
                setIsNextEnabled(true); 
            }
        }
    }, [questDatas, currentIndex]);

      const handleBack = () => {
        if(currentIndex == 0) {
            localStorage.setItem('questionaire_skipped',true)
            navigate('/')
        }
        if(currentIndex>0) {
            setCurrentIndex(prev=> prev - 1)
        }
      }

      const handleNext = () => {
        if(currentIndex == questDatas?.length - 1) {
            handleSubmit()
        }
        const currentQuestion = questDatas[currentIndex];
        const existingAnswerIndex = answerValues.findIndex(answer => answer.questionId === currentQuestion.questionId);
        if (existingAnswerIndex === -1) {
            let defaultValue = null;
            if (currentQuestion.questionType === 'SELECTION') {
                defaultValue = { id: currentQuestion.answerOptionMetaData.options[0].id };
            } else if (currentQuestion.questionType === 'RATING') {
                defaultValue = { value: currentQuestion.answerOptionMetaData.min };
            } else if (currentQuestion.questionType === 'RANGE') {
                defaultValue = { value: currentQuestion.answerOptionMetaData.min };
            }
            setAnswerValues(prev => [...prev, { questionId: currentQuestion.questionId, answerValue: defaultValue }]);
        }
    
        if (currentIndex < questDatas.length - 1) {
            setCurrentIndex(prev => prev + 1);
        }
      }

      const handleChooseOption = (button, data) => {
        setAnswerValues(prev => {
            const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
            if (existingAnswerIndex !== -1) {
                const updatedAnswers = [...prev];
                updatedAnswers[existingAnswerIndex].answerValue = { id: button.id };
                return updatedAnswers;
            } else {
                return [...prev, { questionId: data.questionId, answerValue: { id: button.id } }];
            }
        });
        setIsNextEnabled(true);
      }

      const handleSliderChange = (event, newValue, data) => {
        setAnswerValues(prev => {
          const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
          if (existingAnswerIndex !== -1) {
            const updatedAnswers = [...prev];
            updatedAnswers[existingAnswerIndex].answerValue = {value: newValue};
            return updatedAnswers;
          } else {
            return [...prev, { questionId: data.questionId, answerValue: {value: newValue} }];
          }
        });
      };
      const handleRatingChange = (event, newValue, data) => {
        setAnswerValues(prev => {
          const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
          if (existingAnswerIndex !== -1) {
            const updatedAnswers = [...prev];
            updatedAnswers[existingAnswerIndex].answerValue = {value: newValue};
            return updatedAnswers;
          } else {
            return [...prev, { questionId: data.questionId, answerValue: {value: newValue}  }];
          }
        });
      };

      const handleSubmit = async() => {
        const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ''
        try {
            const response = await ApiService().post(`questionnaire/answers/${userData?.sub_id || user?.sub_id}`,answerValues)
            if(response?.data?.message == "Questionnaire answer created successfully.") setIsComplete(true)
        } catch(error) {
            setError(true)
            captureException(error)
        }
      }

      const handleContinue = () => {
        setIsContinue(true)
      }

      const handleNotNow = () => {
        localStorage.setItem('questionaire_skipped',true)
        navigate('/')
      }

    return(
        // <Box mt={2} sx={{ backgroundColor: colors.background.paper, m:0, width: '100%', height: '100%',padding: { xs: '20px 10px 20px 10px' },  sm: '40px', md:"30px"  }}>
        // <Paper 
        //     sx={{ 
        //         backgroundColor: colors.background.paper, 
        //         height: isContinue ? {xs:"auto",sm:"calc(100vh - 20px)"} : 'auto',
        //         maxHeight: {xs:"calc(100vh - 40px)", sm:"calc(100vh - 60px)"},
        //         overflowY: "auto",
        //         padding: { sm: '30px', xs: '20px 16px' }, 
        //         borderRadius: '10px', 
        //         boxShadow:`0px 1px 13.6px 0px ${colors.border.mild}`  
        //     }}
        // >
<Box 
    sx={{ 
        backgroundColor: colors.background.paper, 
        m: 0, 
        width: '100%', 
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
         padding: { sm: '40px', xs: '20px 16px', lg:"45px", xl:"45px" }, 
        boxSizing: 'border-box'
    }}
>
<Paper 
    sx={{ 
        backgroundColor: colors.background.paper, 
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        boxSizing: 'border-box',   // <-- padding now counts INSIDE the height, not added on top
        overflowY: 'auto',
        padding: { sm: '30px', xs: '20px 16px' }, 
        borderRadius: '10px', 
        boxShadow: `0px 1px 13.6px 0px ${colors.border.mild}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    }}
>
            <Box sx={{width:"100%", height:"100%",}}>
                    {(!complete && !error) ? (<Box sx={{ display:"flex", flexDirection:"column", gap:"20px", width:{xs:"100%"}, height:"100%", alignItems:{xs:"center", md:"unset"}}}>
                    <Logo style={{minWidth:"199px", minHeight:"55px", maxWidth:"100%"}}/>
                    {!isContinue && <Typography sx={{display:{xs:"none", sm:"block"}, color:colors.text.primary,  fontWeight:"600", fontSize:{xs:"24px", lg:"28px", xl:"32px"}, lineHeight:"40px"}}>Your Investment Profile</Typography> }
                    <Box sx={{mt:1, width:{xs:"100%", sm:"80%", md:"50%"}}}>

                        {isContinue && <><Typography sx={{color:colors.text.primary,  fontWeight:"600", fontSize:"20px", lineHeight:"36px",textAlign:{xs:"center", md:"left"}}}>{questDatas[currentIndex]?.questionTitle}</Typography>
                        <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"12px", lineHeight:"21.75px",textAlign:{xs:"center", md:"left"},}}>{questDatas[currentIndex]?.questionDescription}</Typography></>}
                       {isContinue ? (<>
                            {questDatas[currentIndex]?.questionType === "RANGE" && (
                                <>
                                    <Slider 
                                        name="value"
                                        min={questDatas[currentIndex]?.answerOptionMetaData?.min}
                                        max={questDatas[currentIndex]?.answerOptionMetaData?.max}
                                        sx={{ ...customSlider }}
                                        style={{ marginTop: "40px" }}
                                        step={1}
                                         valueLabelDisplay="on"
                                        value={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.value || questDatas[currentIndex]?.answerOptionMetaData?.min}
                                        onChange={(event, newValue) => handleSliderChange(event, newValue, questDatas[currentIndex])}
                                    />
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "15px", lineHeight: "21.75px" }}>
                                            {questDatas[currentIndex]?.answerOptionMetaData?.min}
                                        </Typography>
                                        <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "15px", lineHeight: "21.75px" }}>
                                            {questDatas[currentIndex]?.answerOptionMetaData?.max}
                                        </Typography>
                                    </Box>
                                </>
                            )}
                        {questDatas[currentIndex]?.questionType === "SELECTION" && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', mt: 8, alignItems: {xs:"center", sm:"stretch"} }}>
                                    {questDatas[currentIndex]?.answerOptionMetaData?.options?.map((button) => (
                                        <CustomButton
                                            key={button.id}
                                            onClick={() => handleChooseOption(button, questDatas[currentIndex])}
                                            selected={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.id === button.id}
                                        >
                                            {button.description}
                                        </CustomButton>
                                    ))}
                                </Box>
                            )}

                         {questDatas[currentIndex]?.questionType === "RATING" && (
                        <Box sx={{ mt: 2 }}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: '5px' }}>
                                <Typography sx={{ color: colors.text.primary,  fontWeight: "600", fontSize: "20px", lineHeight: "36px", mb: 2 }}>
                                    {questDatas[currentIndex]?.questionDescription}
                                </Typography>
                                <Typography sx={{ color: colors.text.secondary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>
                                    {questDatas[currentIndex]?.questionDescription}
                                </Typography>
                                <Box sx={{display:"flex", flexDirection:"column", gap:2, width:"fit-content", maxWidth:"100%",  boxShadow: `0px 1px 5px 0px ${colors.border.card}`, borderRadius:"12px", p:"20px" }}>
                                    <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                        <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>Least Familiar</Typography>
                                        <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>Most Familiar</Typography>
                                    </Box>
                                    <Rating
                                        name="customized-color"
                                        value={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.value || questDatas[currentIndex]?.answerOptionMetaData?.min}
                                        precision={1}
                                        onChange={(event, newValue) => handleRatingChange(event, newValue, questDatas[currentIndex])}
                                        icon={<ColorRating style={{ width: "50px" }} fontSize="inherit" />}
                                        emptyIcon={<GreyRating style={{ width: "50px" }} fontSize="inherit" />}
                                         sx={{
                                            '& .MuiRating-icon': {
                                                marginRight: '8px', // gap between icons
                                            },
                                            '& .MuiRating-icon:last-of-type': {
                                                marginRight: 0, // avoid trailing gap
                                            },
                                        }}                                        
                                    />
                                </Box>
                            </Box>
                        </Box>
                        )}
                        </>):(
                             <>
                             <Box sx={{ display: "flex", flexDirection:"column", gap:"10px", 
                                 '@media(min-width:1600px)': {
                                    marginTop:"30px"
                                  }  
                             }}>
                                 <Typography sx={{textAlign:{xs:"center", md:"left"}, color: colors.text.primary,  fontWeight: "500", fontSize: {xs:"25px",md:"28px"}, lineHeight: "34.44px", letterSpacing:"-1" }}>
                                 Do you want to set up your investment profile according to what you need?
                                 </Typography>
                                 <Typography sx={{textAlign:{xs:"center", md:"left"}, color: colors.text.secondary,  fontWeight: "400", fontSize: "15px", lineHeight: "23.2px" }}>
                                 Answer our questionnaire according to your usage purpose so we can help set your profile according to what you need for your business and plan.
                                 </Typography>
                             </Box>
                             <Box sx={{display: "flex", flexDirection:"column", gap:"10px", mt:2,boxShadow:`0px 1px 13.6px 0px ${colors.border.card}`, padding:"24px", borderRadius:"24px",
                                 '@media(min-width:1600px)': {
                                    marginTop:"30px"
                                  }  
                             }}>
                                <Typography sx={{ color: colors.text.primary,  fontWeight: "500", fontSize: {xs:"25px",md:"28px"}, lineHeight: "34.44px", letterSpacing:"-1" }}>
                                Instructions
                                 </Typography>
                                 <ul style={{paddingLeft:"20px", margin:0}}>
                                    <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>Answer all the questions and choose what’s suitable for you</li>
                                    <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>This will let us know what level of investor you are and will adjust things for you accordingly</li>
                                    <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>Select ranges comfortable for your investment to have a better experience investing</li>
                                 </ul>
                             </Box>
                         </>
                        )}
                    </Box>

                    {(!isContinue) && <Box 
                        sx={{
                            display: 'flex',
                            gap: '7.93px',
                            justifyContent:{xs:"center",sm:'flex-end'},
                            my:2,
                            flex:1,
                            width:"100%",
                            alignItems:{xs:"center",sm:'flex-end'},
                            flexDirection:{xs:"column-reverse", sm:"row"},
                            '@media(max-width:660px)': {
                                flexDirection:"column-reverse"
                              }  
                            
                        }}
                        >
                        <Button
                        variant='outlined'
                        onClick={handleNotNow}
                            sx={{
                            maxWidth: '262.92px',
                            width:{xs:"100%", sm:"262.92px"},
                            height: '47.44px',
                            borderRadius: '7.93px',
                            padding: '13.72px 18px',
                            color:colors.text.primary,
                            border: `1px solid ${colors.primary.main}`
                            }}
                        >
                            Not Now
                        </Button>
                        <Button
                        onClick={handleContinue}
                            sx={{
                            maxWidth: '262.92px',
                            width:{xs:"100%", sm:"262.92px"},
                            height: '47.44px',
                            borderRadius: '7.93px',
                            color:colors.primary.contrastText,
                            padding: '13.72px 18px',
                            backgroundColor: colors.primary.main,
                            '&:hover': {
                                backgroundColor: colors.primary.main,
                            },
                            }}
                        >
                           Continue
                        </Button>
                    </Box>}

                    {(isContinue && questDatas?.length >0) && <Box 
                        sx={{
                            display: 'flex',
                            gap: '7.93px',
                            justifyContent:{xs:"center", sm:'flex-end'},
                            mt:2,
                            flex:1,
                            width:"100%",
                            alignItems:{xs:"center", sm:"flex-end"},
                            flexDirection:{xs:"column-reverse", sm:"row"}
                        }}
                        >
                        <Button
                        variant='outlined'
                        onClick={handleBack}
                            sx={{
                            maxWidth: '262.92px',
                            width:{xs:"100%", sm:"262.92px"},
                            height: '47.44px',
                            borderRadius: '7.93px',
                            padding: '13.72px 18px',
                            border: `1px solid ${colors.primary.main}`
                            }}
                        >
                            {currentIndex == 0 ? "Skip" : "Back"}
                        </Button>
                        <Button
                        disabled={!isNextEnabled} 
                        onClick={handleNext}
                            sx={{
                            maxWidth: '262.92px',
                            width:{xs:"100%", sm:"262.92px"},
                            height: '47.44px',
                            borderRadius: '7.93px',
                            color:colors.primary.contrastText,
                            padding: '13.72px 18px',
                            backgroundColor: colors.primary.main,
                            '&:hover': {
                                backgroundColor: colors.primary.main,
                            },
                            }}
                        >
                           {currentIndex == questDatas?.length - 1 ? 'Submit' : 'Next'}
                        </Button>
                    </Box>}
                </Box>) : (
                    error  ? (<Box sx={{margin:'0 auto', height:"100%", display:"flex", flexDirection:"column", gap:"20px", width:{xs:"100%",md:"30%"}, alignItems:"center", justifyContent:"center", minWidth:{xs:"auto", sm:"300px", md:"433px"}}}>
                     <Logo style={{minWidth:"199px", maxWidth:"250px", width:"100%", minHeight:"55px",}}/>
                     <Box
                         component="img"
                         src={UnsubscribeIcon}
                         sx={{maxWidth:"100%"}}
                     />
                     <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", }}>
                         <Typography sx={{color:colors.text.primary,  fontWeight:"500", fontSize:"20px", lineHeight:"31px"}}>Something went wrong</Typography>
                     </Box>
                     <Button
                         sx={{
                         width: {xs:"100%", sm:"262.92px"},
                         maxWidth: '262.92px',
                         height: '47.44px',
                         borderRadius: '7.93px',
                         color:colors.primary.contrastText,
                         padding: '13.72px 18px',
                         backgroundColor: colors.primary.main,
                         '&:hover': {
                             backgroundColor: colors.primary.main,
                         },
                         }}
                         onClick={() =>{
                            navigate('/Questionnaire')
                            window.location.reload();
                         }}
                     >
                         Try again
                     </Button>
                 </Box>) : (
                    <Box sx={{margin:'0 auto', height:{xs:"auto",lg:"100%"}, display:"flex", flexDirection:"column", gap:"12px", width:{xs:"100%",md:"30%"}, alignItems:"center", justifyContent:{xs:"flex-start", lg:"center"}, maxWidth:"422px", minWidth:{xs:"auto", sm:"300px", md:"433px"}}}>
                     <Logo style={{minWidth:"199px", maxWidth:"250px", width:"100%", minHeight:"55px",}}/>
                     <Typography sx={{color:colors.text.primary,  fontWeight:"700",fontSize:{xs:"24px", lg:"30px", xl:"32px"}, lineHeight:"40px", textAlign:"center"}}>Your Investment Profile</Typography>
                     <Box
                         component="img"
                         src={CryptoProfile}
                         sx={{width:"250px", maxWidth:"100%", height:"200px"}}
                     />
                     <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", }}>
                         <Typography sx={{color:colors.text.primary,  fontWeight:"500", fontSize:"20px", lineHeight:"31px", textAlign:"center"}}>You are ready to take off !</Typography>
                         {/* <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"14px", lineHeight:"22px", textAlign:"center"}}>You are a mature investor expecting high returns.</Typography> */}
                     </Box>
                     <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"14px", lineHeight:"22px", textAlign:"center"}}>You are a mature investor expecting high returns.</Typography>
                     <Box sx={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                         <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"14px", lineHeight:"22px", textAlign:"center", mb:2}}>We have curated at TradeTogether a unique pocket fund strategy that facilities crypto returns and</Typography>
                         <Typography sx={{color:colors.primary.main,  fontWeight:"700", fontSize:"14px", lineHeight:"22px", textAlign:"center"}}>takes an opportunistic approach by searching for Defi project with quality management. </Typography>
                     </Box>
                     <Button
                         sx={{
                         width: {xs:"100%", sm:"80%"},
                         maxWidth: '80%',
                         height: '47.44px',
                         borderRadius: '7.93px',
                         color:colors.primary.contrastText,
                         padding: '13.72px 18px',
                         backgroundColor: colors.primary.main,
                         mt:1,
                         '&:hover': {
                             backgroundColor: colors.primary.main,
                         },
                         }}
                         onClick={() => {
                            navigate('/')
                         }}
                     >
                        Confirm
                     </Button>
                 </Box>)
                )}
                
            </Box>
        </Paper>
        </Box>
    )
}





// import  {useState, useEffect, useRef } from 'react'
// import { Typography, Button, Paper, Box,Slider, Rating } from '@mui/material';
// import { customSlider, colors } from "../../Theme"
// import { ReactComponent as Logo } from "../../img/logo.svg"
// import { ReactComponent as ColorRating } from "../../img/colorRating.svg"
// import { ReactComponent as GreyRating } from "../../img/greyRating.svg"
// import CryptoProfile from "../../img/VerifyEmail.png"
// import { useNavigate } from 'react-router-dom';
// import { ApiService } from '../../API/AxiosInstance';
// import UnsubscribeIcon from '../../img/unsubscribeIcon.png';
// import { captureException } from '@sentry/react';
// import { useAuth0 } from '@auth0/auth0-react';

// // Pill-style slider used ONLY for the "What is your investment horizon?" RANGE question.
// // This is intentionally NOT built on MUI's <Slider>: this app's theme carries global
// // MuiSlider style overrides (navy track, ringed thumb) that get applied to every Slider
// // instance regardless of sx, which is why the MUI-based version came out looking wrong.
// // Building it from plain divs avoids that entirely and gives pixel control over the look.
// // NOTE: '#4CAF50' (fill) and '#7FA8CC' (ticks/labels) are placeholder hex values matching
// // the target screenshot - swap these for real tokens from `colors` if you have matching ones
// // (e.g. colors.success?.main for the green).
// const InvestmentHorizonSlider = ({ min, max, value, onChange }) => {
//     const trackRef = useRef(null);
//     const draggingRef = useRef(false);

//     const clamp = (v) => Math.min(max, Math.max(min, v));
//     const percent = max > min ? ((clamp(value) - min) / (max - min)) * 100 : 0;

//     const valueFromClientX = (clientX) => {
//         const rect = trackRef.current.getBoundingClientRect();
//         const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
//         const raw = min + ratio * (max - min);
//         return clamp(Math.round(raw));
//     };

//     const emitChange = (clientX) => {
//         const newValue = valueFromClientX(clientX);
//         onChange(null, newValue);
//     };

//     const handleMove = (e) => {
//         if (!draggingRef.current) return;
//         const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//         emitChange(clientX);
//     };

//     const stopDragging = () => {
//         draggingRef.current = false;
//         document.removeEventListener('mousemove', handleMove);
//         document.removeEventListener('mouseup', stopDragging);
//         document.removeEventListener('touchmove', handleMove);
//         document.removeEventListener('touchend', stopDragging);
//     };

//     const startDragging = (e) => {
//         draggingRef.current = true;
//         const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//         emitChange(clientX);
//         document.addEventListener('mousemove', handleMove);
//         document.addEventListener('mouseup', stopDragging);
//         document.addEventListener('touchmove', handleMove);
//         document.addEventListener('touchend', stopDragging);
//     };

//     useEffect(() => {
//         return () => stopDragging();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const marks = [];
//     for (let i = min; i <= max; i++) marks.push(i);

//     return (
//         <Box sx={{ mt: 6, px: 1 }}>
//             <Box
//                 ref={trackRef}
//                 onMouseDown={startDragging}
//                 onTouchStart={startDragging}
//                 sx={{
//                     position: 'relative',
//                     height: '80px',
//                     borderRadius: '13px',
//                     backgroundColor: '#E3E6EA',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                 }}
//             >
//                 <Box
//                     sx={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         height: '100%',
//                         width: `${percent}%`,
//                         minWidth: '26px',
//                         borderRadius: '13px',
//                         backgroundColor: '#4CAF50',
//                         pointerEvents: 'none',
//                     }}
//                 />
//             </Box>
//             <Box sx={{ position: 'relative', height: '32px', mt: '6px' }}>
//                 {marks.map((m) => {
//                     const pos = max > min ? ((m - min) / (max - min)) * 100 : 0;
//                     return (
//                         <Box
//                             key={m}
//                             sx={{
//                                 position: 'absolute',
//                                 left: `${pos}%`,
//                                 transform: 'translateX(-50%)',
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                             }}
//                         >
//                             <Box sx={{ width: '1px', height: '8px', backgroundColor: '#7FA8CC' }} />
//                             <Typography sx={{ color: '#7FA8CC', fontSize: '13px', fontWeight: 500, mt: '4px', whiteSpace: 'nowrap' }}>
//                                 {m === 0 ? '0' : `${m} y`}
//                             </Typography>
//                         </Box>
//                     );
//                 })}
//             </Box>
//         </Box>
//     );
// };

// export default function Questionaire() {
//     const [questDatas, setQuestDatas] = useState([])
//     const [currentIndex, setCurrentIndex] = useState(0)
//     const [answerValues, setAnswerValues] = useState([])
//     const [isNextEnabled, setIsNextEnabled] = useState(false);
//     const [isContinue, setIsContinue] = useState(false)
//     const [complete, setIsComplete] = useState(false)
//     const [error, setError] = useState(false)
//     const { user } = useAuth0();

//     const navigate = useNavigate()
//     useEffect(() => {
//         getQuestions()
//     },[])

//     const getQuestions = async() => {
//         try {
//             const response = await ApiService().get('questionnaire/questions')
//             if(response?.data?.questions) {
//                 setQuestDatas(response?.data?.questions)
//             }
//         } catch(error) {
//             captureException(error)
//         }
        
//     }

// const CustomButton = ({ children, onClick, selected }) => {
//   return (
//     <Button
//       onClick={onClick}
//       disableRipple
//       sx={{
//         width: { xs: '100%', sm: '262.92px' },
//         minHeight: '47.44px',
//         borderRadius: '7.93px',
//         padding: '13.72px 18px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         textAlign: 'left',
//         textTransform: 'none',
//         backgroundColor: selected ? colors.background.default : colors.background.paper,
//         border: `1.5px solid ${selected ? colors.primary.main : colors.border.default}`,
//         boxShadow: `0px 2px 6px ${colors.border.card}`,
//         color: colors.text.primary,
//         fontWeight: selected ? 600 : 550,
//         '&:hover': {
//           backgroundColor: selected ? colors.background.default : colors.background.paper,
//           borderColor: colors.primary.main,
//         },
//       }}
//     >
//       <span>{children}</span>
//       <Box
//         component="span"
//         sx={{
//           width: 18,
//           height: 18,
//           borderRadius: '50%',
//           border: `2px solid ${selected ? colors.primary.main : colors.border.light}`,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexShrink: 0,
//           ml: '12px',
//         }}
//       >
//         {selected && (
//           <Box
//             component="span"
//             sx={{
//               width: 9,
//               height: 9,
//               borderRadius: '50%',
//               backgroundColor: colors.primary.main,
//             }}
//           />
//         )}
//       </Box>
//     </Button>
//   );
// };

//       useEffect(() => {
//         if (questDatas.length > 0) {
//             const currentQuestion = questDatas[currentIndex];
//             if (currentQuestion.questionType === 'SELECTION' && !answerValues[currentIndex]?.answerValue?.id) {
//                 setIsNextEnabled(false); 
//             } else {
//                 setIsNextEnabled(true); 
//             }
//         }
//     }, [questDatas, currentIndex]);

//       const handleBack = () => {
//         if(currentIndex == 0) {
//             localStorage.setItem('questionaire_skipped',true)
//             navigate('/')
//         }
//         if(currentIndex>0) {
//             setCurrentIndex(prev=> prev - 1)
//         }
//       }

//       const handleNext = () => {
//         if(currentIndex == questDatas?.length - 1) {
//             handleSubmit()
//         }
//         const currentQuestion = questDatas[currentIndex];
//         const existingAnswerIndex = answerValues.findIndex(answer => answer.questionId === currentQuestion.questionId);
//         if (existingAnswerIndex === -1) {
//             let defaultValue = null;
//             if (currentQuestion.questionType === 'SELECTION') {
//                 defaultValue = { id: currentQuestion.answerOptionMetaData.options[0].id };
//             } else if (currentQuestion.questionType === 'RATING') {
//                 defaultValue = { value: currentQuestion.answerOptionMetaData.min };
//             } else if (currentQuestion.questionType === 'RANGE') {
//                 defaultValue = { value: currentQuestion.answerOptionMetaData.min };
//             }
//             setAnswerValues(prev => [...prev, { questionId: currentQuestion.questionId, answerValue: defaultValue }]);
//         }
    
//         if (currentIndex < questDatas.length - 1) {
//             setCurrentIndex(prev => prev + 1);
//         }
//       }

//       const handleChooseOption = (button, data) => {
//         setAnswerValues(prev => {
//             const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
//             if (existingAnswerIndex !== -1) {
//                 const updatedAnswers = [...prev];
//                 updatedAnswers[existingAnswerIndex].answerValue = { id: button.id };
//                 return updatedAnswers;
//             } else {
//                 return [...prev, { questionId: data.questionId, answerValue: { id: button.id } }];
//             }
//         });
//         setIsNextEnabled(true);
//       }

//       const handleSliderChange = (event, newValue, data) => {
//         setAnswerValues(prev => {
//           const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
//           if (existingAnswerIndex !== -1) {
//             const updatedAnswers = [...prev];
//             updatedAnswers[existingAnswerIndex].answerValue = {value: newValue};
//             return updatedAnswers;
//           } else {
//             return [...prev, { questionId: data.questionId, answerValue: {value: newValue} }];
//           }
//         });
//       };
//       const handleRatingChange = (event, newValue, data) => {
//         setAnswerValues(prev => {
//           const existingAnswerIndex = prev.findIndex(answer => answer.questionId === data.questionId);
//           if (existingAnswerIndex !== -1) {
//             const updatedAnswers = [...prev];
//             updatedAnswers[existingAnswerIndex].answerValue = {value: newValue};
//             return updatedAnswers;
//           } else {
//             return [...prev, { questionId: data.questionId, answerValue: {value: newValue}  }];
//           }
//         });
//       };

//       const handleSubmit = async() => {
//         const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ''
//         try {
//             const response = await ApiService().post(`questionnaire/answers/${userData?.sub_id || user?.sub_id}`,answerValues)
//             if(response?.data?.message == "Questionnaire answer created successfully.") setIsComplete(true)
//         } catch(error) {
//             setError(true)
//             captureException(error)
//         }
//       }

//       const handleContinue = () => {
//         setIsContinue(true)
//       }

//       const handleNotNow = () => {
//         localStorage.setItem('questionaire_skipped',true)
//         navigate('/')
//       }

//     return(
//         <Box mt={2} sx={{ backgroundColor: colors.background.paper, m:0, width: '100%', height: '100%',padding: { sm: '40px', xs: '20px 10px 20px 10px' },  }}>
//         <Paper 
//             sx={{ 
//                 backgroundColor: colors.background.paper, 
//                 height: isContinue ? {xs:"auto",sm:"calc(100vh - 20px)"} : 'auto',
//                 maxHeight: {xs:"calc(100vh - 40px)", sm:"calc(100vh - 80px)"},
//                 overflowY: "auto",
//                 padding: { sm: '30px', xs: '20px 16px' }, 
//                 borderRadius: '10px', 
//                 boxShadow:`0px 1px 13.6px 0px ${colors.border.mild}`  
//             }}
//         >
//             <Box sx={{width:"100%", height:"100%",}}>
//                     {(!complete && !error) ? (<Box sx={{ display:"flex", flexDirection:"column", gap:"20px", width:{xs:"100%"}, height:"100%", alignItems:{xs:"center", md:"unset"}}}>
//                     <Logo style={{minWidth:"199px", minHeight:"55px", maxWidth:"100%"}}/>
//                     {!isContinue && <Typography sx={{display:{xs:"none", sm:"block"}, color:colors.text.primary,  fontWeight:"600", fontSize:{xs:"24px", lg:"28px", xl:"32px"}, lineHeight:"40px"}}>Your Investment Profile</Typography> }
//                     <Box sx={{mt:1, width:{xs:"100%", sm:"80%", md:"50%"}}}>

//                         {isContinue && <><Typography sx={{color:colors.text.primary,  fontWeight:"600", fontSize:"20px", lineHeight:"36px",textAlign:{xs:"center", md:"left"}}}>{questDatas[currentIndex]?.questionTitle}</Typography>
//                         <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"12px", lineHeight:"21.75px",textAlign:{xs:"center", md:"left"},}}>{questDatas[currentIndex]?.questionDescription}</Typography></>}
//                        {isContinue ? (<>
//                             {questDatas[currentIndex]?.questionType === "RANGE" && (
//                                 questDatas[currentIndex]?.questionTitle === "What is your investment horizon?" ? (
//                                     <InvestmentHorizonSlider
//                                         min={questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         max={questDatas[currentIndex]?.answerOptionMetaData?.max}
//                                         value={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.value || questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         onChange={(event, newValue) => handleSliderChange(event, newValue, questDatas[currentIndex])}
//                                     />
//                                 ) : (
//                                 <>
//                                     <Slider 
//                                         name="value"
//                                         min={questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         max={questDatas[currentIndex]?.answerOptionMetaData?.max}
//                                         sx={{ ...customSlider }}
//                                         style={{ marginTop: "40px" }}
//                                         step={1}
//                                          valueLabelDisplay="on"
//                                         value={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.value || questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         onChange={(event, newValue) => handleSliderChange(event, newValue, questDatas[currentIndex])}
//                                     />
//                                     <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                                         <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "15px", lineHeight: "21.75px" }}>
//                                             {questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         </Typography>
//                                         <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "15px", lineHeight: "21.75px" }}>
//                                             {questDatas[currentIndex]?.answerOptionMetaData?.max}
//                                         </Typography>
//                                     </Box>
//                                 </>
//                                 )
//                             )}
//                         {questDatas[currentIndex]?.questionType === "SELECTION" && (
//                                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', mt: 8, alignItems: {xs:"center", sm:"stretch"} }}>
//                                     {questDatas[currentIndex]?.answerOptionMetaData?.options?.map((button) => (
//                                         <CustomButton
//                                             key={button.id}
//                                             onClick={() => handleChooseOption(button, questDatas[currentIndex])}
//                                             selected={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.id === button.id}
//                                         >
//                                             {button.description}
//                                         </CustomButton>
//                                     ))}
//                                 </Box>
//                             )}

//                          {questDatas[currentIndex]?.questionType === "RATING" && (
//                         <Box sx={{ mt: 2 }}>
//                             <Box sx={{ display: "flex", flexDirection: "column", gap: '5px' }}>
//                                 <Typography sx={{ color: colors.text.primary,  fontWeight: "600", fontSize: "20px", lineHeight: "36px", mb: 2 }}>
//                                     {questDatas[currentIndex]?.questionDescription}
//                                 </Typography>
//                                 <Typography sx={{ color: colors.text.secondary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>
//                                     {questDatas[currentIndex]?.questionDescription}
//                                 </Typography>
//                                 <Box sx={{display:"flex", flexDirection:"column", gap:2, width:"fit-content", maxWidth:"100%",  boxShadow: `0px 1px 5px 0px ${colors.border.card}`, borderRadius:"12px", p:"20px" }}>
//                                     <Box sx={{display:"flex", justifyContent:"space-between"}}>
//                                         <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>Least Familiar</Typography>
//                                         <Typography sx={{ color: colors.text.primary,  fontWeight: "400", fontSize: "12px", lineHeight: "21.75px" }}>Most Familiar</Typography>
//                                     </Box>
//                                     <Rating
//                                         name="customized-color"
//                                         value={answerValues.find(answer => answer.questionId === questDatas[currentIndex]?.questionId)?.answerValue?.value || questDatas[currentIndex]?.answerOptionMetaData?.min}
//                                         precision={1}
//                                         onChange={(event, newValue) => handleRatingChange(event, newValue, questDatas[currentIndex])}
//                                         icon={<ColorRating style={{ width: "50px" }} fontSize="inherit" />}
//                                         emptyIcon={<GreyRating style={{ width: "50px" }} fontSize="inherit" />}
//                                          sx={{
//                                             '& .MuiRating-icon': {
//                                                 marginRight: '8px', // gap between icons
//                                             },
//                                             '& .MuiRating-icon:last-of-type': {
//                                                 marginRight: 0, // avoid trailing gap
//                                             },
//                                         }}                                        
//                                     />
//                                 </Box>
//                             </Box>
//                         </Box>
//                         )}
//                         </>):(
//                              <>
//                              <Box sx={{ display: "flex", flexDirection:"column", gap:"10px", 
//                                  '@media(min-width:1600px)': {
//                                     marginTop:"30px"
//                                   }  
//                              }}>
//                                  <Typography sx={{textAlign:{xs:"center", md:"left"}, color: colors.text.primary,  fontWeight: "500", fontSize: {xs:"25px",md:"28px"}, lineHeight: "34.44px", letterSpacing:"-1" }}>
//                                  Do you want to set up your investment profile according to what you need?
//                                  </Typography>
//                                  <Typography sx={{textAlign:{xs:"center", md:"left"}, color: colors.text.secondary,  fontWeight: "400", fontSize: "15px", lineHeight: "23.2px" }}>
//                                  Answer our questionnaire according to your usage purpose so we can help set your profile according to what you need for your business and plan.
//                                  </Typography>
//                              </Box>
//                              <Box sx={{display: "flex", flexDirection:"column", gap:"10px", mt:2,boxShadow:`0px 1px 13.6px 0px ${colors.border.card}`, padding:"24px", borderRadius:"24px",
//                                  '@media(min-width:1600px)': {
//                                     marginTop:"30px"
//                                   }  
//                              }}>
//                                 <Typography sx={{ color: colors.text.primary,  fontWeight: "500", fontSize: {xs:"25px",md:"28px"}, lineHeight: "34.44px", letterSpacing:"-1" }}>
//                                 Instructions
//                                  </Typography>
//                                  <ul style={{paddingLeft:"20px", margin:0}}>
//                                     <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>Answer all the questions and choose what’s suitable for you</li>
//                                     <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>This will let us know what level of investor you are and will adjust things for you accordingly</li>
//                                     <li style={{marginBottom:"10px", color: colors.text.primary,  fontWeight: "400", fontSize: "16px", lineHeight: "26px" }}>Select ranges comfortable for your investment to have a better experience investing</li>
//                                  </ul>
//                              </Box>
//                          </>
//                         )}
//                     </Box>

//                     {(!isContinue) && <Box 
//                         sx={{
//                             display: 'flex',
//                             gap: '7.93px',
//                             justifyContent:{xs:"center",sm:'flex-end'},
//                             my:2,
//                             flex:1,
//                             width:"100%",
//                             alignItems:{xs:"center",sm:'flex-end'},
//                             flexDirection:{xs:"column-reverse", sm:"row"},
//                             '@media(max-width:660px)': {
//                                 flexDirection:"column-reverse"
//                               }  
                            
//                         }}
//                         >
//                         <Button
//                         variant='outlined'
//                         onClick={handleNotNow}
//                             sx={{
//                             maxWidth: '262.92px',
//                             width:{xs:"100%", sm:"262.92px"},
//                             height: '47.44px',
//                             borderRadius: '7.93px',
//                             padding: '13.72px 18px',
//                             color:colors.text.primary,
//                             border: `1px solid ${colors.primary.main}`
//                             }}
//                         >
//                             Not Now
//                         </Button>
//                         <Button
//                         onClick={handleContinue}
//                             sx={{
//                             maxWidth: '262.92px',
//                             width:{xs:"100%", sm:"262.92px"},
//                             height: '47.44px',
//                             borderRadius: '7.93px',
//                             color:colors.primary.contrastText,
//                             padding: '13.72px 18px',
//                             backgroundColor: colors.primary.main,
//                             '&:hover': {
//                                 backgroundColor: colors.primary.main,
//                             },
//                             }}
//                         >
//                            Continue
//                         </Button>
//                     </Box>}

//                     {(isContinue && questDatas?.length >0) && <Box 
//                         sx={{
//                             display: 'flex',
//                             gap: '7.93px',
//                             justifyContent:{xs:"center", sm:'flex-end'},
//                             mt:2,
//                             flex:1,
//                             width:"100%",
//                             alignItems:{xs:"center", sm:"flex-end"},
//                             flexDirection:{xs:"column-reverse", sm:"row"}
//                         }}
//                         >
//                         <Button
//                         variant='outlined'
//                         onClick={handleBack}
//                             sx={{
//                             maxWidth: '262.92px',
//                             width:{xs:"100%", sm:"262.92px"},
//                             height: '47.44px',
//                             borderRadius: '7.93px',
//                             padding: '13.72px 18px',
//                             border: `1px solid ${colors.primary.main}`
//                             }}
//                         >
//                             {currentIndex == 0 ? "Skip" : "Back"}
//                         </Button>
//                         <Button
//                         disabled={!isNextEnabled} 
//                         onClick={handleNext}
//                             sx={{
//                             maxWidth: '262.92px',
//                             width:{xs:"100%", sm:"262.92px"},
//                             height: '47.44px',
//                             borderRadius: '7.93px',
//                             color:colors.primary.contrastText,
//                             padding: '13.72px 18px',
//                             backgroundColor: colors.primary.main,
//                             '&:hover': {
//                                 backgroundColor: colors.primary.main,
//                             },
//                             }}
//                         >
//                            {currentIndex == questDatas?.length - 1 ? 'Submit' : 'Next'}
//                         </Button>
//                     </Box>}
//                 </Box>) : (
//                     error  ? (<Box sx={{margin:'0 auto', height:"100%", display:"flex", flexDirection:"column", gap:"20px", width:{xs:"100%",md:"30%"}, alignItems:"center", justifyContent:"center", minWidth:{xs:"auto", sm:"300px", md:"433px"}}}>
//                      <Logo style={{minWidth:"199px", maxWidth:"250px", width:"100%", minHeight:"55px",}}/>
//                      <Box
//                          component="img"
//                          src={UnsubscribeIcon}
//                          sx={{maxWidth:"100%"}}
//                      />
//                      <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", }}>
//                          <Typography sx={{color:colors.text.primary,  fontWeight:"500", fontSize:"20px", lineHeight:"31px"}}>Something went wrong</Typography>
//                      </Box>
//                      <Button
//                          sx={{
//                          width: {xs:"100%", sm:"262.92px"},
//                          maxWidth: '262.92px',
//                          height: '47.44px',
//                          borderRadius: '7.93px',
//                          color:colors.primary.contrastText,
//                          padding: '13.72px 18px',
//                          backgroundColor: colors.primary.main,
//                          '&:hover': {
//                              backgroundColor: colors.primary.main,
//                          },
//                          }}
//                          onClick={() =>{
//                             navigate('/Questionnaire')
//                             window.location.reload();
//                          }}
//                      >
//                          Try again
//                      </Button>
//                  </Box>) : (<Box sx={{margin:'0 auto', height:{xs:"auto",lg:"100%"}, display:"flex", flexDirection:"column", gap:"20px", width:{xs:"100%",md:"30%"}, alignItems:"center", justifyContent:{xs:"flex-start", lg:"center"}, maxWidth:"422px", minWidth:{xs:"auto", sm:"300px", md:"433px"}}}>
//                      <Logo style={{minWidth:"199px", maxWidth:"250px", width:"100%", minHeight:"55px",}}/>
//                      <Typography sx={{color:colors.text.primary,  fontWeight:"700", fontSize:"24px", lineHeight:"40px", textAlign:"center"}}>Your Investment Profile</Typography>
//                      <Box
//                          component="img"
//                          src={CryptoProfile}
//                          sx={{width:"250px", maxWidth:"100%", height:"200px"}}
//                      />
//                      <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", }}>
//                          <Typography sx={{color:colors.text.primary,  fontWeight:"500", fontSize:"20px", lineHeight:"31px", textAlign:"center"}}>You are ready to take off !</Typography>
//                          <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"14px", lineHeight:"22px", textAlign:"center"}}>You are a mature investor expecting high returns.</Typography>
//                      </Box>
//                      <Box sx={{display:"flex", flexDirection:"column", alignItems:"center"}}>
//                          <Typography sx={{color:colors.text.secondary,  fontWeight:"400", fontSize:"14px", lineHeight:"22px", textAlign:"center", mb:2}}>We have curated at TradeTogether a unique pocket fund strategy “The Alts Risk Reward” that facilities investment returns and</Typography>
//                          <Typography sx={{color:colors.primary.main,  fontWeight:"700", fontSize:"14px", lineHeight:"22px", textAlign:"center"}}>takes an opportunistic approach by searching for Defi project with quality management. </Typography>
//                      </Box>
//                      <Button
//                          sx={{
//                          width: {xs:"100%", sm:"262.92px"},
//                          maxWidth: '262.92px',
//                          height: '47.44px',
//                          borderRadius: '7.93px',
//                          color:colors.primary.contrastText,
//                          padding: '13.72px 18px',
//                          backgroundColor: colors.primary.main,
//                          '&:hover': {
//                              backgroundColor: colors.primary.main,
//                          },
//                          }}
//                          onClick={() => {
//                             navigate('/')
//                          }}
//                      >
//                         Confirm
//                      </Button>
//                  </Box>)
//                 )}
                
//             </Box>
//         </Paper>
//         </Box>
//     )
// }